import JustValidate from 'just-validate';

export default class FormValidator {
    /**
     * @param {HTMLFormElement} form
     * @param {Function} onSubmitCallback - Функція, що виконається після успішної валідації
     */
    constructor(form, onSubmitCallback = null) {
        if (!form) return;

        this.form = form;
        this.onSubmitCallback = onSubmitCallback;
        this.jvInstance = null;

        this.init();
    }

    init() {
        this.jvInstance = new JustValidate(this.form, {
            validateBeforeSubmitting: true,
            errorFieldCssClass: "is-invalid",
            errorLabelCssClass: "field-error-message fz-12 clr-danger marg-t-4 d-block",
        });

        this.addDynamicRules();

        if (this.onSubmitCallback) {
            this.jvInstance.onSuccess((e) => this.onSubmitCallback(e));
        }
    }

    /**
     * Автоматично додає правила для полів у поточній формі
     */
    addDynamicRules() {
        // Знаходимо всі поля, що вимагають заповнення
        const inputs = this.form.querySelectorAll('[required], input[type="tel"]');

        inputs.forEach((input) => {
            const rules = [];

            if (input.required) {
                rules.push({
                    rule: "required",
                    errorMessage: window.agds.i18n.required,
                });
            }

            if (input.type === "tel") {
                rules.push({
                    rule: "custom",
                    validator: (value) => {
                        if (!value) {
                            return true;
                        }

                        const digits = String(value).replace(/\D/g, "");
                        if (!input.required && (digits === "" || digits === "380")) {
                            return true;
                        }

                        return /^380\d{9}$/.test(digits);
                    },
                    errorMessage: window.agds?.i18n?.phoneInvalid || "Please enter a complete phone number.",
                });
            }

            if (rules.length) {
                this.jvInstance.addField(input, rules);
            }
        });
    }

    /**
     * Перестворює валідатор.
     * Викликається після того, як у форму підвантажились нові поля по REST.
     */
    refresh() {
        if (this.jvInstance) {
            this.jvInstance.destroy();
        }
        this.init();
    }
}
